'use client'

import { Button } from '@sushiswap/ui'
import { JazzIcon } from '@sushiswap/ui/icons/JazzIcon'
import { useMemo } from 'react'
import { useSidebar } from 'src/app/(networks)/_ui/sidebar'
import { ConnectButton } from 'src/lib/wagmi/components/connect-button'
import { type WalletNamespace, useWallets } from 'src/lib/wallet'
import { shortenAddress } from 'sushi'
import type { EvmChainId } from 'sushi/evm'
import { useConnection } from 'wagmi'
import { SidebarTrigger } from '../sidebar/sidebar-trigger'

interface UserPortfolioProps {
  namespace?: WalletNamespace
}

export function UserPortfolio({ namespace }: UserPortfolioProps) {
  const wallets = useWallets()

  const wallet = wallets.evm

  const { address: wagmiAddress } = useConnection()

  const address = wallet?.account ?? wagmiAddress

  const { open } = useSidebar()

  const walletCount = useMemo(() => {
    if (!wallets) return 0
    return Object.values(wallets)?.filter((wallet) => wallet !== undefined)
      .length
  }, [wallets])

  if (!address)
    return <ConnectButton variant="secondary" namespace={namespace} />

  return (
    <SidebarTrigger>
      <Button
        variant="secondary"
        onClick={() => open()}
        className="items-center"
      >
        <JazzIcon diameter={20} address={address} />
        <span className="hidden sm:block">{shortenAddress(address)}</span>
        {walletCount > 1 ? (
          <div className="w-4 h-4 rounded-full bg-blue text-white font-medium text-[10px] flex items-center justify-center">
            +{walletCount - 1}
          </div>
        ) : null}
      </Button>
    </SidebarTrigger>
  )
}
